import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/sparkle.vue
var o = {
	name: "DtIconSparkle",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--sparkle"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Sparkle",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M9.264 1c.05 0 .093.034.107.082.23.745.81 1.335 1.545 1.572a.12.12 0 0 1 .084.113.12.12 0 0 1-.084.114 2.39 2.39 0 0 0-1.529 1.522.131.131 0 0 1-.123.092.131.131 0 0 1-.124-.092 2.392 2.392 0 0 0-1.509-1.516.127.127 0 0 1-.087-.12c0-.055.036-.103.087-.12a2.393 2.393 0 0 0 1.525-1.565A.114.114 0 0 1 9.264 1Zm0 6.505c.05 0 .093.034.108.081.23.746.81 1.335 1.544 1.572a.12.12 0 0 1 .084.114.12.12 0 0 1-.084.114 2.39 2.39 0 0 0-1.529 1.522.131.131 0 0 1-.123.092.131.131 0 0 1-.124-.092 2.393 2.393 0 0 0-1.509-1.516.127.127 0 0 1-.087-.12c0-.055.036-.103.087-.12a2.393 2.393 0 0 0 1.525-1.566.114.114 0 0 1 .108-.081ZM4.503 9.239v.27l-.082-.014a.267.267 0 0 1-.13-.097l-.038-.075c-.021-.064-.046-.127-.07-.19l.32.106Zm.25.084-.038.075a.262.262 0 0 1-.212.11v-.27l.318-.105a4.902 4.902 0 0 0-.068.19Zm-.251-4.926A5.882 5.882 0 0 1 2.918 5.99a5.882 5.882 0 0 1 1.584 1.595 5.885 5.885 0 0 1 1.585-1.596 5.883 5.883 0 0 1-1.585-1.592ZM7.7 6.279a4.87 4.87 0 0 0-2.879 2.854l-.318.106-.32-.106a4.875 4.875 0 0 0-2.738-2.802l-.267-.098A.258.258 0 0 1 1 5.99c0-.111.073-.209.178-.243a4.872 4.872 0 0 0 3.106-3.19.231.231 0 0 1 .219-.165c.1 0 .188.068.218.165A4.873 4.873 0 0 0 7.868 5.76c.1.032.169.124.17.23 0 .105-.07.198-.17.23l-.168.06Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=sparkle.js.map